export const enum Role {
  User = "user",
  Assistant = "assistant",
  System = "system",
}

export const enum OrganizationRole {
  Owner = "owner",
  Admin = "admin",
  Member = "member",
}

export const enum WorkspaceRole {
  Owner = "owner",
  Admin = "admin",
  Member = "member",
}

export interface DefaultScope {
  organizationId: string
  organizationRole: OrganizationRole
  workspaceId: string
  workspaceRole: WorkspaceRole
}

export interface Profile {
  defaultWorkspaceId?: string
  defaultSearch: boolean
  defaultOrganizationId: string
  defaultScopes: Record<string, DefaultScope> // organizationId -> DefaultScope
  preferredLLM?: string | null
  workspaceOrganizationMap?: Record<string, string> // workspaceId -> organizationId
}

export interface User {
  id: number
  name: string
  email: string
  avatar?: string
  hasUsablePassword?: boolean
  hasGoogleLogin?: boolean
  profile: Profile
}

export const NoOwner = {
  id: 0,
  name: "No Owner",
  email: "unassigned",
  avatar: "",
  profile: {},
} as User

export interface Member extends User {
  role: OrganizationRole | WorkspaceRole
  permissions: Set<string>
}
